module.exports = __webpack_public_path__ + "img/rec-09.9fde7169.jpg";